<dx-popup (onHidden)="this.onHidden()"
          [dragEnabled]="true"
          [resizeEnabled]="false"
          [visible]="this.visible"
          [width]="300"
          [height]="'auto'"
          [title]="this.title"
>
  <div *dxTemplate="let data of 'content'" class="container">

    <div class="rows">
      <div *ngFor="let row of this.rows" class="option">
        <div class="label">{{ row.label }}</div>
        <div class="input">
          <dx-switch [value]="this.visibility[row.section]"
                     (onValueChanged)="this.onSwitchChanged(row.section, $event)"
          ></dx-switch>
        </div>
      </div>
    </div>

    <div class="buttons">
      <dx-button (onClick)="this.close()" text="Close" width="100%"></dx-button>
    </div>

  </div>
</dx-popup>
